import { useEffect, useState } from "react";
import { FilterValues } from "../../../data-model/filterValues";
import {
  AsteraOncologyExternalFilterPayload,
  ASTERA_ONCOLOGY_EXTERNAL_DEFAULT_ORDER_BY,
} from "../utils/asteraOncologyExternalFilterPayload";
import { buildAsteraFilterPayload } from "../utils/buildAsteraFilterPayload";

export { ASTERA_ONCOLOGY_EXTERNAL_DEFAULT_ORDER_BY };
export type { AsteraOncologyExternalFilterPayload };

export interface UseFilterPayloadReturn {
  filterPayload: AsteraOncologyExternalFilterPayload | null;
  setFilterPayload: React.Dispatch<
    React.SetStateAction<AsteraOncologyExternalFilterPayload | null>
  >;
}

export const useFilterPayload = (
  validFilters: FilterValues[],
  searchTerm: string,
  initialDataFetchingExecuted: boolean,
  dateFromStart: string,
  dateFromEnd: string,
  pageSize: number = 120,
): UseFilterPayloadReturn => {
  const [filterPayload, setFilterPayload] =
    useState<AsteraOncologyExternalFilterPayload | null>(null);

  useEffect(() => {
    if (!initialDataFetchingExecuted) {
      setFilterPayload(null);
    } else {
      setFilterPayload(
        buildAsteraFilterPayload(
          validFilters,
          searchTerm,
          dateFromStart,
          dateFromEnd,
          pageSize,
        ),
      );
    }
  }, [
    validFilters,
    searchTerm,
    initialDataFetchingExecuted,
    dateFromStart,
    dateFromEnd,
    pageSize,
  ]);

  return {
    filterPayload,
    setFilterPayload,
  };
};
